import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ffbdf30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attendWrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "form"
}
const _hoisted_4 = { class: "attendName" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "nameError" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "eMailError" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "attendeesError" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "commentError" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary mx-1",
  type: "submit"
}, "Abschicken", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_FormControlInput = _resolveComponent("FormControlInput")!
  const _component_FormControlSlider = _resolveComponent("FormControlSlider")!
  const _component_form_control_textarea = _resolveComponent("form-control-textarea")!
  const _component_ValidationForm = _resolveComponent("ValidationForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAttendance = !_ctx.showAttendance))
      }, " Für diesen Termin anmelden ", 512), [
        [_vShow, !_ctx.showAttendance && _ctx.messages.length === 0]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
        return (_openBlock(), _createBlock(_component_Message, {
          onClose: _ctx.resetMessage,
          severity: message.severity,
          key: message.content
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(message.content), 1)
          ]),
          _: 2
        }, 1032, ["onClose", "severity"]))
      }), 128)),
      (_ctx.showAttendance)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!_ctx.isLoading && !_ctx.isAttendand && _ctx.showForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_ValidationForm, {
                    name: "attendeesForm",
                    onSubmit: _ctx.onProcessForm
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_FormControlInput, {
                          required: _ctx.calendarConfig.name_required,
                          label: "Name",
                          name: "name",
                          class: "filterKeyText",
                          defaultvalue: _ctx.form.name
                        }, null, 8, ["required", "defaultvalue"])
                      ]),
                      _hoisted_5,
                      _hoisted_6,
                      _createElementVNode("div", null, [
                        _createVNode(_component_FormControlInput, {
                          required: true,
                          label: "e-Mail-Adresse",
                          type: "email",
                          name: "email",
                          defaultvalue: _ctx.form.email
                        }, null, 8, ["defaultvalue"])
                      ]),
                      _hoisted_7,
                      _hoisted_8,
                      _createElementVNode("div", null, [
                        _createVNode(_component_FormControlSlider, {
                          required: _ctx.calendarConfig.count_attendees_required,
                          label: "Anzahl der Personen",
                          type: "number",
                          min: 1,
                          max: 20,
                          name: "countAttendees",
                          defaultvalue: 1
                        }, null, 8, ["required"])
                      ]),
                      _hoisted_9,
                      _hoisted_10,
                      _createElementVNode("div", null, [
                        _createVNode(_component_form_control_textarea, {
                          required: _ctx.calendarConfig.comment_required,
                          label: "Bemerkungen",
                          class: "attendComment",
                          name: "attendComment",
                          defaultvalue: _ctx.form.comment,
                          rows: 5
                        }, null, 8, ["required", "defaultvalue"])
                      ]),
                      _hoisted_11,
                      _hoisted_12,
                      _hoisted_13,
                      _createElementVNode("button", {
                        class: "btn btn-primary mx-1",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showAttendance = !_ctx.showAttendance), ["prevent"]))
                      }, "Abbrechen")
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}